module.exports = __webpack_public_path__ + "img/ka12.bded2152.jpg";